export const SAVED_FILTERS_ENDPOINT = {
  JOBS: "job_filters",
  TALENTS: "talent_filters",
} as const;

export type SavedFiltersEndpoint = ObjectValues<typeof SAVED_FILTERS_ENDPOINT>;
